import React from 'react';
import ProductDescription from './ProductDescription';
import UpdatePaymentBanPaymentInfo from './UpdatePaymentBanPaymentInfo';

const UpdatePaymentBanDetailsRow = ({ban, tooltipIdPrefix = 'update-payment-ban-details'}) => {
  return (
    <div className='update-payment-ban-details-row'>
      <div className='update-payment-ban-details-row__ban-number'>חשבון {ban.banNumber}</div>
      <ProductDescription
        productDescriptions={ban.productDescriptions}
        banNumber={ban.banNumber}
        className='update-payment-ban-details-row__product'
        tooltipIdPrefix={tooltipIdPrefix}
        showTooltip={false}
      />
      <UpdatePaymentBanPaymentInfo ban={ban} block='update-payment-ban-details-row' layout='split' />
    </div>
  );
};

export default UpdatePaymentBanDetailsRow;
